import { KioskPage, KioskRemoteRecoveryHost } from "../pages/kiosk";
import { KioskErrorBoundaryReporter } from "./kiosk-error-boundary";

export function KioskAppShell() {
  return (
    <>
      <KioskRemoteRecoveryHost />
      <KioskErrorBoundaryReporter>
        <KioskPage />
      </KioskErrorBoundaryReporter>
    </>
  );
}
